import React from "react";
import "./styles.scss";

export const DeleteConfirmationModal = ({
  isOpen,
  onClose,
  itemName,
  hasLinkedRecords,
  transactionCount,
  requestCount,
  onArchive,
  onDelete,
  isLoading,
}) => {
  if (!isOpen) return null;

  return (
    <div
      id="deleteConfirmationModal"
      className="modal fade in example-modal"
      tabIndex="-1"
      role="dialog"
      aria-labelledby="modal-title-delete"
    >
      <div className="modal-dialog" role="document">
        <div className="modal-content">
          <div className="modal-header">
            <button
              type="button"
              onClick={onClose}
              className="close"
              aria-label="Close"
              disabled={isLoading}
            >
              &times;
            </button>
            <h4 id="modal-title-delete" className="modal-title">
              Delete {itemName}
            </h4>
          </div>
          <div className="modal-body">
            {hasLinkedRecords ? (
              <>
                <p className="warning-text">
                  <strong>Warning:</strong> This item has linked records:
                </p>
                <ul className="linked-records-list">
                  {transactionCount > 0 && (
                    <li>{transactionCount} transaction(s)</li>
                  )}
                  {requestCount > 0 && (
                    <li>{requestCount} request(s)</li>
                  )}
                </ul>
                <p>Please choose an action:</p>
                <div className="delete-actions">
                  <button
                    className="btn btn-warning delete-action-btn"
                    onClick={onArchive}
                    disabled={isLoading}
                  >
                    {isLoading ? "Processing..." : "Archive (Hide from UI)"}
                  </button>
                  <button
                    className="btn btn-danger delete-action-btn"
                    onClick={onDelete}
                    disabled={isLoading}
                  >
                    {isLoading ? "Processing..." : "Delete Permanently"}
                  </button>
                  <p className="delete-warning-note">
                    <small>
                      <strong>Note:</strong> Permanent deletion will remove all linked records and cannot be undone.
                    </small>
                  </p>
                </div>
              </>
            ) : (
              <p>Are you sure you want to delete "{itemName}"?</p>
            )}
          </div>
          {!hasLinkedRecords && (
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-default"
                onClick={onClose}
                disabled={isLoading}
              >
                Cancel
              </button>
              <button
                type="button"
                className="btn btn-danger"
                onClick={onDelete}
                disabled={isLoading}
              >
                {isLoading ? "Deleting..." : "Delete"}
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
